export const COLORS = {
	brand: "#1CBAA7",
	brandDark: "#1E1E1E",
	brandLight: "#F4F7F9",
	dark: "#1e1e1e",
	light: "#fff",
	tableHeader: "rgba(30, 30, 30, 0.7)",
	navColor: "rgba(255, 255, 255, 0.6)",
	menuBoxShadow: "0px 5px 15px 10px rgba(187, 193, 200, 0.1)",
	tableBoxShadow: "0px 5px 15px 10px rgba(187, 193, 200, 0.05)",
	lightBlue: "#DCEBF4",
	red: "#DF5151",
	lightGray: "#AAAAAA",
	gray: "rgba(30, 30, 30, 0.3)",
	mediumGray: "rgba(30, 30, 30, 0.7)",
	bgGray: "#F5F5F5",
	progressBg: "#C4C4C4",
};
